import actionTypes from './actionTypes';

export const initialState = {
  post: null,
  isLoading: false,
  postError: null,
  relatedPosts: [],
  popularPosts: [],
  topics: [],
  pinnedPosts: [],
  nextPosts: [],
  freePostId: null,
  roles: null,
  isSecondPageBlockMsgBoxVisible: false,
  isLoginBlockMsgBoxVisible: false,
  loginBlockUsername: null,
};

const sortResponses = responses => {
  return [...responses].sort((a, b) => {
    if (a.order < b.order)
      return -1;
    if (a.order > b.order)
      return 1;
    return 0;
  });
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_POST:
      return {
        ...state,
        isLoading: true,
        postError: null,
      };
    case actionTypes.FETCH_POST_SUCCESS:
      return {
        ...state,
        post: action.post,
        isLoading: false,
        freePostId: state.freePostId || action.post.id,
      };
    case actionTypes.FETCH_POST_FAILURE:
      return {
        ...state,
        isLoading: false,
        postError: {
          status: action.error.response.status || 500,
          message: action.error.message,
        },
      };
    case actionTypes.FETCH_RELATED_POSTS_SUCCESS:
      return {
        ...state,
        relatedPosts: action.posts,
      };
    case actionTypes.FETCH_RELATED_POSTS_FAILURE:
      return {
        ...state,
      };
    case actionTypes.FETCH_POPULAR_POSTS_SUCCESS:
      return {
        ...state,
        popularPosts: action.posts,
      };
    case actionTypes.FETCH_TOPICS_SUCCESS:
      return {
        ...state,
        topics: action.topics,
      };
    case actionTypes.FETCH_PINNED_POSTS_SUCCESS:
      return {
        ...state,
        pinnedPosts: action.posts,
      };
    case actionTypes.FETCH_NEXT_POSTS_SUCCCESS:
      return {
        ...state,
        nextPosts: action.posts,
      };
    case actionTypes.UPDATE_POST_LOCK_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          isLocked: action.isLocked,
        },
      };
    case actionTypes.UPDATE_POST_PIN_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          isPinned: action.isPinned,
        },
      };
    case actionTypes.DELETE_POST_SUCCESS:
      if (action.superParentId !== action.postId) {
        const responses = state.post.responses.filter(p => p.id !== action.postId);
        return {
          ...state,
          post: {
            ...state.post,
            totalResponses: state.post.totalResponses - 1,
            responses,
          },
        };
      }
      return {
        ...state,
      };
    case actionTypes.DELETE_POST_REPLY_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          totalResponses: state.post.totalResponses - 1,
          responses: state.post.responses.filter(p => p.id !== action.postId),
        },
      };
    case actionTypes.LIKE_POST_SUCCESS:
      if (action.postId === state.post.id) {
        return {
          ...state,
          post: {
            ...state.post,
            hasRated: action.isLiked,
            numRatings: parseInt(state.post.numRatings) + (action.isLiked ? 1 : -1),
          },
        };
      }

      return {
        ...state,
        post: {
          ...state.post,
          responses: state.post.responses.map(resp => resp.id === action.postId
            ? {
                ...resp,
                hasRated: action.isLiked,
                numRatings: parseInt(resp.numRatings) + (action.isLiked ? 1 : -1),
              }
            : resp),
        },
      };
    case actionTypes.FOLLOW_POST_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          isFollowing: true,
        },
      };
    case actionTypes.UNFOLLOW_POST_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          isFollowing: false,
        },
      };
    case actionTypes.REPLY_POST_SUCCESS: {
      const responses = [
        ...(state.post.responses || []),
        action.post,
      ];
      return {
        ...state,
        post: {
          ...state.post,
          responses: sortResponses(responses),
          totalResponses: responses.length,
        },
      };
    }
    case actionTypes.UPDATE_POST_REPLY_SUCCESS:
      return {
        ...state,
        post: {
          ...state.post,
          responses: state.post.responses.map(resp => resp.id === action.post.id
            ? { ...action.post }
            : resp),
        },
      };
    case actionTypes.SHOW_SECOND_PAGE_BLOCK_MESSAGE_BOX:
      return {
        ...state,
        isSecondPageBlockMsgBoxVisible: state.isLoginBlockMsgBoxVisible ? false : true,
        loginBlockUsername: null,
      };
    case actionTypes.SHOW_LOGIN_BLOCK_MESSAGE_BOX:
      return {
        ...state,
        isSecondPageBlockMsgBoxVisible: false,
        isLoginBlockMsgBoxVisible: true,
        loginBlockUsername: action.username,
      };
  }
  return state;
}
